import { FC } from 'react'
import constants from '../../../constants'

const LogoIcon = ({ ...props }) => {
  return constants.BRAND === 'sports-research' ? (
    <svg
      width="36"
      height="66"
      viewBox="0 0 36 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.2846 0.165527H12.8797C6.4244 0.165527 1.198 5.39654 1.198 11.8405C1.198 18.2845 6.43199 23.5231 12.8797 23.5231H17.1806M16.0428 65.3409L0.803552 46.8808H0.77321V46.8429H0.765625V46.8125L17.173 23.5307H18.6674C25.1226 23.5307 30.3566 28.7617 30.3566 35.2057C30.3566 41.3238 25.6536 46.3349 19.6611 46.8429H19.9493L35.2189 65.3485H16.0428V65.3409Z"
        fill="#212721"
      />
    </svg>
  ) : (
    <svg
      width="42"
      height="68"
      viewBox="0 0 42 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M31.2081 25.8455C28.6222 22.377 26.1198 18.2314 26.1476 13.752C26.1755 10.0145 28.7335 5.78546 31.9495 3.83789C32.7651 3.34636 33.6919 3.01249 34.4519 2.46531C34.8412 2.18708 35.3324 1.47297 34.906 0.897973C34.6929 0.610474 34.35 0.629022 34.0441 0.42499C31.9217 0.369345 30.4203 1.02781 28.9652 1.63991C26.1755 2.80845 23.8399 4.2645 21.5043 5.84111C18.659 7.76086 16.0361 9.97739 13.6727 12.4629C8.36208 18.0737 4.33044 24.8253 1.79097 32.1149C0.437819 35.9822 -0.11827 40.2112 0.0207525 44.2918C0.104166 46.7124 0.5305 49.2535 1.27195 51.5535C1.9856 53.7701 3.09778 55.8289 4.29337 57.8229C8.05623 64.0737 14.4049 67.4958 21.6989 67.5608C23.4043 67.57 25.1374 67.3103 26.7779 66.8559C33.6826 64.9269 38.7616 59.8168 40.8655 53.0003C43.0435 45.9426 40.3557 37.5681 36.1294 31.7995C34.6095 29.7314 32.7466 27.9044 31.2081 25.8362"
        fill="white"
      />
    </svg>
  )
}

export default LogoIcon
